import React from 'react';
import { formatSortCode } from '../account-utils';
import AccountId from './AccountId';
export default function PaymentAccountId(_ref) {
  var accountId = _ref.accountId,
    agentIdentification = _ref.agentIdentification,
    agentScheme = _ref.agentScheme,
    showLabels = _ref.showLabels,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(AccountId, {
    className: className,
    items: accountIdItems(accountId, agentIdentification, agentScheme, showLabels)
  });
}
function accountIdItems(accountId, agentIdentification, agentScheme, showLabels) {
  if (!accountId) return [];
  var _accountId$get$toJS = accountId.get('account').toJS(),
    identification = _accountId$get$toJS.identification,
    scheme = _accountId$get$toJS.scheme,
    bic = _accountId$get$toJS.bic;
  if (scheme === 'BBAN') {
    var isV1Payment = accountId.has('agent');
    var sortcode = isV1Payment ? accountId.getIn(['agent', 'identification']) : identification.substr(0, 6);
    var number = isV1Payment ? identification : identification.substr(6);
    return [formatSortCode(sortcode), number];
  } else if (scheme === 'IBAN') {
    var bicText = showLabels ? "BIC ".concat(bic) : bic;
    var ibanText = showLabels ? "IBAN ".concat(identification) : identification;
    return bic ? [bicText, ibanText] : [ibanText];
  } else if (scheme === 'OTHER') {
    var accountNumberText = showLabels ? "Account no. ".concat(identification) : identification;
    var agentNumberText = showLabels ? "".concat(agentScheme, " ").concat(agentIdentification) : agentIdentification;
    return agentIdentification ? [accountNumberText, agentNumberText] : [accountNumberText];
  } else if (scheme === 'PAN') {
    return [identification];
  } else {
    return [];
  }
}